//import React, { useContext } from "react";
//import { FirebaseContext } from "../../FirebaseContext";
import { CharacterCreation } from "../CharacterCreation/"
import '../../App.css';
import './Main.css';

export const Main = () => {
    //const { userData } = useContext(FirebaseContext);

    return (
        <div>
            <CharacterCreation />
        </div>
    );
  }